// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"microphone-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 8C22 11.3137 19.3137 14 16 14C12.6863 14 10 11.3137 10 8C10 4.68629 12.6863 2 16 2C19.3137 2 22 4.68629 22 8Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M10 8C10 11.3137 12.6863 14 16 14L6.50007 21.5002C6.50007 21.5002 5.45836 22.457 3.50007 20.5002C1.54178 18.5433 2.50007 17.5002 2.50007 17.5002L10 8Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 14C12.6863 14 10 11.3137 10 8M16 14L6.50007 21.5002C6.50007 21.5002 5.45836 22.457 3.50007 20.5002C1.54178 18.5433 2.50007 17.5002 2.50007 17.5002L10 8M16 14C19.3137 14 22 11.3137 22 8C22 4.68629 19.3137 2 16 2C12.6863 2 10 4.68629 10 8","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9 15L8 16","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Microphone2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'microphone-2',
    ref,
    icon: element,
  },
));

Microphone2Icon.displayName = 'Microphone2Icon';

export default Microphone2Icon;
